(function () {
  window.dataLayer = window.dataLayer || [];

  const toNum = (x) => {
    const n = Number(x);
    return Number.isFinite(n) ? n : 0;
  };

  const recentAtc = new Map(); // key -> timestamp
const ATC_DEDUPE_MS = 1500;

const isDuplicateATC = (key) => {
  const now = Date.now();

  // purge old keys
  for (const [k, ts] of recentAtc.entries()) {
    if (now - ts > ATC_DEDUPE_MS) recentAtc.delete(k);
  }

  if (recentAtc.has(key)) return true;
  recentAtc.set(key, now);
  return false;
};

  const getCurrency = () =>
    window.Shopify?.currency?.active ||
    window.Shopify?.currency?.currency ||
    document.documentElement.getAttribute("data-shopify-currency") ||
    "USD";

  const getPageType = () => {
    const path = window.location.pathname || "";
    if (document.getElementById("dl-product")) return "product";
    if (document.getElementById("dl-collection")) return "collection";
    if (path.startsWith("/products/")) return "product";
    if (path.startsWith("/collections/")) return "collection";
    if (path.startsWith("/search")) return "search";
    if (path === "/cart" || path.startsWith("/cart/")) return "cart";
    return "other";
  };

  const buildItem = (added) => {
    const quantity = toNum(added.quantity || 1);
    const unitPrice =
      (added.final_price != null ? toNum(added.final_price) : toNum(added.price)) / 100;

    return {
      item_id: String(added.variant_id || added.id || ""),
      item_name: added.product_title || added.title || "",
      item_brand: added.vendor || "",
      item_category: added.product_type || "",
      item_variant: added.variant_title || "",
      price: unitPrice,
      quantity
    };
  };

const pushATC = (added, source) => {
  const item = buildItem(added);

  // SUPER-STRICT DEDUPE: ignore any second ATC within 1500ms, regardless of payload
  const now = Date.now();
  window.__lastATC = window.__lastATC || 0;
  if (now - window.__lastATC < 1500) return;
  window.__lastATC = now;

  const value = (item.price || 0) * (item.quantity || 1);

  window.dataLayer.push({
    event: "add_to_cart",
    atc_source: source,          // <-- THIS IS KEY
    page_type: getPageType(),
    ecommerce: {
      currency: getCurrency(),
      value,
      items: [item]
    }
  });
};


  // Match /cart/add.js even if the URL is absolute, relative, or has query params,
  // and also catch cases where it appears as just "add.js"
  const isAddUrl = (url) => {
    if (!url) return false;
    const u = String(url);
    return /\/cart\/add\.js(\?|$)/.test(u) || /\/cart\/add(\?|$)/.test(u) || /add\.js(\?|$)/.test(u);
  };

  // ---- FETCH HOOK ----
  const originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = async function (...args) {
      const res = await originalFetch.apply(this, args);

      try {
        const url = (typeof args[0] === "string") ? args[0] : (args[0]?.url || "");
        if (!isAddUrl(url)) return res;

        const cloned = res.clone();
        const contentType = cloned.headers.get("content-type") || "";

        // Some themes/apps return JSON with a non-json content-type, so don't hard-block on it.
        if (!res.ok) return res;

        const text = await cloned.text();
        if (!text) return res;

        const added = JSON.parse(text);
        if (added && (added.id || added.variant_id)) pushATC(added, "fetch");
      } catch (e) {}

      return res;
    };
  }

  // ---- XHR HOOK ----
  const XHR = window.XMLHttpRequest;
  if (typeof XHR === "function") {
    const originalOpen = XHR.prototype.open;
    const originalSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url, ...rest) {
      this.__gtm_url = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    XHR.prototype.send = function (body) {
      this.addEventListener("load", function () {
        try {
          const url = this.__gtm_url || "";
          if (!isAddUrl(url)) return;
          if (this.status < 200 || this.status >= 300) return;

          const text = this.responseText || "";
          if (!text) return;

          const added = JSON.parse(text);
          if (added && (added.id || added.variant_id)) pushATC(added, "xhr");
        } catch (e) {}
      });

      return originalSend.call(this, body);
    };
  }
})();


(function () {
  window.dataLayer = window.dataLayer || [];

  const el = document.getElementById("dl-product");
  if (!el) return;

  const p = JSON.parse(el.textContent || "{}");
  if (!p.variant_id) return;

  window.dataLayer.push({
    event: "product_view",
    page_type: "product",
    ecommerce: {
      currency: p.currency || "CAD",
      value: Number(p.price || 0),
      items: [{
        item_id: String(p.variant_id),
        item_name: p.product_title || "",
        item_brand: p.vendor || "",
        item_category: p.product_type || "",
        item_variant: p.variant_title || "",
        price: Number(p.price || 0),
        quantity: 1
      }]
    }
  });
})();

(function () {
  window.dataLayer = window.dataLayer || [];

  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!form || form.action?.includes("/search") !== true) return;

    const fd = new FormData(form);
    const q = (fd.get("q") || "").toString().trim();
    if (!q) return;

    window.dataLayer.push({
      event: "search",
      page_type: "search",
      search_term: q
    });
  });
})();

(function () {
  window.dataLayer = window.dataLayer || [];

  const el = document.getElementById("dl-collection");
  if (!el) return;

  const c = JSON.parse(el.textContent || "{}");
  if (!c.id) return;

  window.dataLayer.push({
    event: "collection_view",
    page_type: "collection",
    collection: { id: String(c.id), title: c.title || "" }
  });
})();